import React, { Fragment } from "react";
import { connect } from "react-redux";
import { withData } from "../common/WithData";
import StudentController from "../api/StudentController";
import { Container, Row, Col } from "react-bootstrap";
import { DictionaryControl } from "../components/DictionaryControl";
import StringArrayRenderer from "../components/renderers/StringArrayRenderer";
import ErrorBoundary from "./ErrorBoundry";
import FinancialView from "../components/FinancialView";
import ActivityView from "../components/ActivityView";

class StudentLife extends React.Component
{
    studentController: StudentController;

    constructor(props: any)
    {
        super(props);

        this.studentController = new StudentController();
    }

    render(): React.ReactNode
    {
        let studentLifeClass = "";
        let studentFicanceClass = "";

        if (this.props.settings.length > 0)
        {
            studentLifeClass = (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psStudentLife")[0].isActive == true) ? "d-none" : "";
            studentFicanceClass = (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psStudentFinancial")[0].isActive == true) ? "d-none" : "";
        }

        const ActivityData = withData(
            ActivityView,
            "Activity",
            async () => await this.studentController.getActivities()
        );

        const FinanceData = withData(
            FinancialView,
            "Finance",
            async () => await this.studentController.getFinancial()
        );

        const activityMap = { ilgMember: "ILG Member" };
        const financialMap = { rataAppointments: "RA/TA Appointments" };

        const items = [];
        items.push(
            {
                keys: ["studentActivities"],
                renderer: StringArrayRenderer
            });

        return <Fragment>
            <ErrorBoundary>
                <Row>
                    <Col lg={6} className={studentLifeClass + " right-border"}>
                        <h2>Activities</h2>
                        <ActivityData ignores={"hiddenFields"} maps={activityMap} renderers={items} />
                    </Col>
                    <Col className={studentFicanceClass} lg={6}>
                        <h2>Financial</h2>
                        <FinanceData ignores={"hiddenFields"} maps={financialMap} />
                    </Col>
                </Row>
            </ErrorBoundary>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent,
    role: state.app.user.role,
    settings: state.app.privacySettings
});

export default connect(mapStateToProps)(StudentLife);